import { getProductsData } from './dataApi';
// import { generatePlaceholderImage } from '../utils/imageUtils';

export const getProductById = (id) => {
  const productsData = getProductsData();
  const product = productsData.find(p => p.id === id);
  
  if (!product) {
    throw new Error('Product not found');
  }

  return product;

  // // Generate up to 7 dummy images, minimum 1
  // const generateDummyImages = () => {
  //   const count = Math.floor(Math.random() * 7) + 1;
  //   return Array.from({ length: count }, (_, index) => 
  //     generatePlaceholderImage(400, 400, `${product.title || 'Product'} ${index + 1}`)
  //   );
  // };

  // // Generate a longer dummy description
  // const generateDummyDescription = () => {
  //   return "This is an extended dummy description for the product. It provides more details about the item's features, benefits, and potential uses. The description aims to give customers a comprehensive understanding of the product, helping them make an informed purchase decision.".slice(0, 256);
  // };

  // // Add missing fields with dummy values if they don't exist
  // return {
  //   ...product,
  //   title: product.title || product.name || "Untitled Product", // Use 'title' or fallback to 'name'
  //   description: product.description || generateDummyDescription(),
  //   images: product.images && product.images.length > 0 ? product.images : generateDummyImages(),
  //   brand: product.brand || "Unknown Brand",
  //   name: product.name || product.title || "Untitled Product",
  //   price: parseFloat(product.price) || 0.0,
  //   meta: product.meta || { ic: 1 }, // Ensure meta field exists with image count
  // };
};

// ... rest of the existing code ...
